import esri = __esri;

export interface IAssetIdConfig {
    columnName?: string;
    displayName?: string;
    idType?: string;
    propName?: string;
    fieldName?: string;
    layerId?: number;
}

interface IAOISettings {
    assetIdConfig: IAssetIdConfig[];
    mapPickerConfig: any;
}

export interface IColumn {
    name?: string;
    alias?: string;
    columnIdentifier?: IColumnIdentifier
}

export interface IColumnIdentifier {
    name?: string;
}

export interface IFeature {
    attributes?: IAttribute[];
    sourceLayer?: ILayer;
    geometry?: any;
    layerName?: string;
    isAdded?: boolean;
}

export type IGraphicType = "proposal" | "highlight";

export interface IAttribute {
    columnName?: string;
    displayName?: string;
    value?: any;
}

export interface ILayerToAdd {
    columnName?: string;
    layerId?: number;
    value?: string;
}

export interface ILayerSettings extends ILayer {
    zoomToLayer?: boolean;
    generateNewLayer?: boolean;
    query?: any;
}

export interface ILayerColumnList {
    layerId?: number;
    columnList?: string[];
}

export interface ILayer {
    id?: number;
    layer?: ILayer;
    mapcoreProps?: any;
}

export interface ILayerColumnValueOverrides {
    layerId?: number;
    columnValueDescriptions?: IColumnValuesAndDescriptions[];
}

export interface IColumnValuesAndDescriptions {
    columnName: string;
    valuesAndDescriptions: string[];
}

export interface IGraphicsLayer extends esri.GraphicsLayer {
    mapcoreProps: any;
}

export interface IRMSKey {
    countyCode?: string;
    stateRouteNumber?: string;
    beginSegment?: string;
    sideIndicator?: string;
    juris?: string;
}

export interface IEsriLayer extends esri.Layer {
    mapcoreProps: any;
}

export interface IFeature {
    attributes?: IAttribute[];
    sourceLayer?: ILayer;
    geometry?: any;
    layerName?: string;
    isAdded?: boolean;
}

export enum Juris {
    State = 1,
    Turnpike = 2,
    StateAgency = 3,
    NonStateNonFederalAid = 4,
    NonStateFederalAid = 5,
    TollBridge = 6,
    LocalRoad = 8
}
